import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/pages/LandingPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "SolveDesk Admin";
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, nofollow");
    return () => robots.setAttribute("content", "index, follow, max-image-preview:large, max-snippet:-1");
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("soldesk_admin_token", data.token);
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary/40 flex flex-col items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <Logo />
        </div>
        <div className="rounded-3xl border border-black/5 bg-white shadow-[0_20px_40px_rgb(0,0,0,0.08)] p-10">
          <h1 className="font-display text-2xl font-semibold text-slate-900 text-center" data-testid="admin-login-headline">Admin Sign In</h1>
          <p className="text-sm text-muted-foreground text-center mt-2 mb-8">Manage Solve Desk inquiries</p>
          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div className="space-y-1.5">
              <Label htmlFor="admin-email">Email</Label>
              <Input id="admin-email" type="email" data-testid="admin-email-input" placeholder="admin@solvedesk.space"
                className="h-12 rounded-xl" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="admin-password">Password</Label>
              <Input id="admin-password" type="password" data-testid="admin-password-input" placeholder="••••••••"
                className="h-12 rounded-xl" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
            <Button type="submit" disabled={loading} data-testid="admin-login-submit-button"
              className="w-full h-12 rounded-full bg-slate-900 hover:bg-slate-800 text-white font-semibold transition-transform duration-200 hover:-translate-y-0.5">
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
        <p className="text-center mt-8">
          <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200" data-testid="back-to-site-link">
            ← Back to solvedesk.space
          </Link>
        </p>
      </div>
    </div>
  );
}
